module.exports = __webpack_public_path__ + "954e8cbe212670ee1ac770edd339b89d.png";